import styled from 'styled-components';

import { Colour } from '@xemplo/style-constants';

export const SearchWrapper = styled.div`
  box-sizing: content-box;
  padding: 8px;
  border-bottom: 1px solid ${Colour.Gray[200]};
  background: ${Colour.Gray[100]};
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;
